import Table from './table.vue'
import TableRow from './table-row.vue'
import TableCell from './table-cell.vue'
import TableHead from './table-head.vue'
import TableBody from './table-body.vue'
import TableHeader from './table-header.vue'

export {
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  TableHeader,
}
